exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-select-button-container {\r\n  -ms-flex: 1;\r\n      flex: 1;\r\n  min-width: 210px;\r\n}\r\n\r\n\r\n@media screen and (max-width: 800px) {\r\n  .action-button-container {\r\n    -ms-flex: 1;\r\n        flex: 1;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 640px) {\r\n  .group-select-button-container button {\r\n      padding-left: 4em;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/location-groups/location-groups.component.css
// module id = ../../../../../src/app/components/organization/location-groups/location-groups.component.css
// module chunks = main